import { render, staticRenderFns } from "./TTTest.vue?vue&type=template&id=5cf7a204&scoped=true&"
import script from "./TTTest.vue?vue&type=script&lang=js&"
export * from "./TTTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cf7a204",
  null
  
)

export default component.exports